import type { HomeApiJackpotItem } from '../types/home-aggregate'
import type { JackpotTickerItem } from '../types/jackpot-ticker'

function jackpotEventId(item: HomeApiJackpotItem, index: number) {
  const eventId = item.event_id?.trim()
  if (eventId) return eventId
  return `jackpot-${index}`
}

/** 金额原文加千分位，不经 JS number，避免精度丢失 */
export function formatWinAmountDisplay(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return '0'
  const negative = trimmed.startsWith('-')
  const unsigned = negative ? trimmed.slice(1) : trimmed
  const [intRaw = '0', fracRaw = ''] = unsigned.split('.')
  const intPart = intRaw.replace(/\D/g, '') || '0'
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const frac = fracRaw.replace(/0+$/, '')
  const sign = negative ? '-' : ''
  return frac ? `${sign}${grouped}.${frac}` : `${sign}${grouped}`
}

/** GET /home jackpot_items 与 WS big_win:batch 共用映射（无本地假图兜底） */
export function mapJackpotItems(input: HomeApiJackpotItem[]): JackpotTickerItem[] {
  return input.map((item, index) => {
    const eventId = jackpotEventId(item, index)
    return {
      id: item.id != null ? String(item.id) : eventId,
      eventId,
      gameId: item.game_id != null ? String(item.game_id) : '',
      thumbnailUrl: (item.game_icon_url ?? '').trim(),
      thumbnailKey: (item.game_icon_key ?? '').trim() || undefined,
      gameTitle: item.game_name || '热门游戏',
      winAmount: item.win_amount ?? '0',
      currency: item.currency || '',
      provider: '',
      gameName: item.game_name || '',
      username: item.player_mask || '***',
    }
  })
}
